module.exports = __webpack_public_path__ + "img/advantage-05.ffd30a7a.png";